import { Controller } from 'react-hook-form';
import React from 'react';
import {
  Box, TextField, Typography,
} from '@mui/material';
import { NumberFormatCustom } from './format/number-format-custom';

function CurrencyTextFieldCustom({
  control, name, label, rules = null, read, variant = 'outlined', buildingTrade = false,
}: any) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field, fieldState,
      }) => {
        return (
          <Box
            sx={{
              bgcolor: buildingTrade ? 'background.default' : 'inherit',
              paddingBottom: buildingTrade ? 2 : 'inherit',
              paddingX: buildingTrade ? 2 : 'inherit',
            }}
          >
            <TextField
              label={label}
              value={field.value || ''}
              size="small"
              variant={variant}
              placeholder="0,00 €"
              onChange={(e) => field.onChange(e.target.value)}
              onBlur={field.onBlur}
              InputProps={{
                inputComponent: NumberFormatCustom as any,
                readOnly: read,
              }}
              fullWidth
            />
            {fieldState?.error?.message
                && <Typography variant="caption" fontWeight="bold" color="error">{fieldState.error.message}</Typography>}
          </Box>
        );
      }}
    />
  );
}

export {
  CurrencyTextFieldCustom,
};
